import React, { Component } from 'react';

class PickHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.renderOwnerHistory = this.renderOwnerHistory.bind(this);
    }

    renderOwnerHistory(details) {
        let detailHistoryOutput = [];
        if (details && details.length > 1 && this.state.show) {
            detailHistoryOutput.push(
                <h4 className="pl-4">Trade History</h4>
            );
            details.forEach((detail) => {
                let team = this.props.teams[detail.team];
                detailHistoryOutput.push(
                    <div className="row">
                        <div className="col-12 pl-5 pb-3">
                            <div>Team - {team.teamName} ({team.owner})</div>
                            <div className={"pl-5" + (detail.notes ? "" : " d-none")}>Notes - {detail.notes}</div>
                        </div>
                    </div>
                )
            });
        }
        return detailHistoryOutput;
    }

    render() {
        let pick = this.props.pick;
        let pickIndex = this.props.pickIndex;
        let currentTeam;
        if (this.props.teams && pick.details && pick.details[0]) {
            currentTeam = this.props.teams[pick.details[0].team];
        }
        return (
            <div className={"col-12 pl-4"}>
                <h5>Pick {pickIndex + 1}</h5>
                <div className="col-12">
                    {pick.details && pick.details.length > 1 && 
                        <button className={"btn float-left mr-2" + (this.state.show ? ' btn-danger' : ' btn-success')} 
                            onClick={()=> this.setState({show: !this.state.show})}>
                            <i className={"fa" + (this.state.show ? ' fa-minus' : ' fa-plus')}/>
                        </button>
                    }
                    <p className="pt-1">{currentTeam ? `Team - ${currentTeam.teamName} (${currentTeam.owner})` : ''}</p>
                    {
                        this.renderOwnerHistory(pick.details)
                    }
                </div>
                <div className="col-12">
                    <h6 className={(pick.draftPick ? "" : "d-none")}>Draft Pick - {pick.draftPick}</h6>
                </div>
            </div>
        );
    }
}

export default PickHistory;



// WEBPACK FOOTER //
// ./src/components/Draft/PickHistory.js